import { RouteObject } from 'react-router-dom';
import deliveryRoutes from './delivery/routes';
import togReceivedRoutes from './togReceived/routes';
import togRequestsRoutes from './togRequests/routes';
import togPackingRoutes from './togPacking/routes';
import togUnpackingRoutes from './togUnpacking/routes';
import shipmentBatchRoutes from './shipmentBatch/routes';
import inboundRoutes from './inbound/routes';
import loadingRoutes from './loading/routes';
import togReportRoutes from './togReports/routes';

// ERP Delivery Module - All delivery management routes
export const erpDeliveryRoutes: RouteObject[] = [
  {
    path: 'delivery',
    children: deliveryRoutes,
  },
  {
    path: 'tog-received',
    children: togReceivedRoutes,
  },
  {
    path: 'tog-requests',
    children: togRequestsRoutes,
  },
  {
    path: 'tog-packing',
    children: togPackingRoutes,
  },
  {
    path: 'tog-unpacking',
    children: togUnpackingRoutes,
  },
  {
    path: 'shipment-batch',
    children: shipmentBatchRoutes,
  },
  {
    path: 'inbound',
    children: inboundRoutes,
  },
  {
    path: 'loading',
    children: loadingRoutes,
  },
  {
    path: 'tog-reports',
    children: togReportRoutes,
  },
];

export default erpDeliveryRoutes;
